import { useMutation, useQueryClient } from '@tanstack/react-query'
import { showErrorToast } from '@bpinternal/ui-kit-next'
import { getApiClient } from '../../stores'
import { ClientInputs } from '@botpress/client'
import { getQueryKey } from '~/services'

type UpsertTableRowsParams = ClientInputs['upsertTableRows']

export function useUpsertTableRows({ botId, workspaceId }: { workspaceId: string; botId: string }) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (params: UpsertTableRowsParams) => {
      return await getApiClient({ workspaceId, botId }).upsertTableRows(params)
    },
    onSuccess: async (_, { table }) => {
      queryClient.invalidateQueries({
        queryKey: getQueryKey('workspaces_/$workspaceId_/bots_/$botId_/tables/$table_', {
          workspaceId,
          botId,
          table,
        }),
      })
    },
    onError: async (error: Error) => {
      showErrorToast(error.message)
    },
  })
}
